import { Injectable } from '@angular/core';
import { MicrosoftAuthBaseService } from './microsoft-auth-base.service';

@Injectable({
  providedIn: 'root',
})
export class MicrosoftAuthDisabledService implements MicrosoftAuthBaseService{

   async initialize(): Promise<string | null> {
        console.log('Microsoft authentication is disabled on HTTP.');
        return null;
      }

      async loginMicrosoft(): Promise<void> {
        window.alert('Microsoft Login is not available on HTTP.');
      }

      async logoutMicrosoft(): Promise<void> {
        console.log('Microsoft logout is not applicable on HTTP.');
      }

      isLoggedIn(): boolean {
        return false;
      }

}
